<input type="file" accept="image/*" capture="camera"
  (change)="saveImage($event)"
  [required]="required" [disabled]="disabled"/>
  @if (showSpinner) {
    <mat-icon class="spin">sync</mat-icon>
    }<br />
    @if (showThumbnail && value) {
      <img [src]="value" [style.maxWidth]="thumbnailMaxSize" />
    }
